import Vue from 'vue'
import i18n from '@/plugins/i18n'
import {
  ERROR_CODE_SERVER,
  ERROR_NAME_CUSTOM,
  ERROR_NAME_NETWORK,
  ERROR_NAME_SERVER,
  ERROR_NAME_VALIDATION,
  ERROR_MESSAGE_SERVER,
  ERROR_MESSAGE_VALIDATION,
  ERROR_CODE_VALIDATION,
  ERROR_CODE_NETWORK
} from '@/constants/settings'

function CustomError (code, message) {
  Error.call(this, message)
  this.name = ERROR_NAME_CUSTOM

  this.code = code
  this.message = message

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, CustomError)
  } else {
    this.stack = (new Error()).stack
  }
  if (Vue.getEnvironmentName() === 'development') {
    // eslint-disable-next-line no-console
    console.error(this.message)
  }
}
CustomError.prototype = Object.create(Error.prototype)
CustomError.prototype.constructor = CustomError

function ServerError () {
  CustomError.call(this, ERROR_CODE_SERVER, i18n.t(ERROR_MESSAGE_SERVER))
  this.name = ERROR_NAME_SERVER
  // console.log(i18n.t(ERROR_MESSAGE_SERVER))
}

ServerError.prototype = Object.create(CustomError.prototype)
ServerError.prototype.constructor = ServerError

function ValidationError (message) {
  CustomError.call(this, ERROR_CODE_VALIDATION, message || i18n.t(ERROR_MESSAGE_VALIDATION))
  this.name = ERROR_NAME_VALIDATION
  // console.log(i18n.t(ERROR_MESSAGE_VALIDATION))
}

ValidationError.prototype = Object.create(CustomError.prototype)
ValidationError.prototype.constructor = ValidationError

Vue.errorsTypes = Vue.prototype.$errorsTypes = {
  ValidationError,
  ServerError,
  NetworkError
}

function NetworkError (error) {
  CustomError.call(this, ERROR_CODE_NETWORK, i18n.t(error.message))
  this.name = ERROR_NAME_NETWORK
  this.stack = error.stack
  // console.log(i18n.t(ERROR_MESSAGE_NETWORK))
}

NetworkError.prototype = Object.create(CustomError.prototype)
NetworkError.prototype.constructor = NetworkError
